module.exports = __webpack_public_path__ + "img/anniu1ac.1f5fbc98.png";